var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"share-btn-box"}},[_c('button',{attrs:{"id":"tweet-btn"},on:{"click":function($event){return _vm.tweet()}}},[_vm._v("折角なのでツイートする")])])}
var staticRenderFns = []

export { render, staticRenderFns }